/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Hero_Cta_FreeInputs */

const en_homepage_hero_cta_free = /** @type {(inputs: Homepage_Hero_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started for Free`)
};

const es_homepage_hero_cta_free = /** @type {(inputs: Homepage_Hero_Cta_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comienza gratis`)
};

/**
* | output |
* | --- |
* | "Get Started for Free" |
*
* @param {Homepage_Hero_Cta_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_hero_cta_free = /** @type {((inputs?: Homepage_Hero_Cta_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Hero_Cta_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_hero_cta_free(inputs)
	return en_homepage_hero_cta_free(inputs)
});